const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {atCurrResult} = require("../vault/StateCursors");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const CopyTable = require("../util/CopyTable");

const styles = require("./styles/ServerErrorIndicator.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		hasResultError: !!atCurrResult(vaultState).getIn("updateFails"),
		disconnected: vaultState.connected === false,
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ServerErrorIndicator",

		propTypes: {
			hasResultError: PT.bool.isRequired,
			disconnected: PT.bool.isRequired,
		},

		render: function() {
			const message = CopyTable.forGlobalErrorNotice(this.props);
			if (!message) {
				return null;
			}

			return <div className={styles.main}>{message}</div>;
		},
	})
);
